import {STREAM_EVENTS_LOAD, STREAM_EVENTS_SAVE, STREAM_EVENTS_UPDATE} from "../constants/StreamEvents";
import {IStreamEventsState} from "../reducers/StreamEvents";
import {IStreamServiceResponse} from "../../model/service/api/StreamEventsService";

export const load = () => {
  return {
    type: STREAM_EVENTS_LOAD
  }
};

export const save = (response: IStreamServiceResponse) => {
  return {
    type: STREAM_EVENTS_SAVE,
    ...response
  }
};

export const update = (changes: Partial<IStreamEventsState>) => {
  return {
    type: STREAM_EVENTS_UPDATE,
    ...changes
  }
};


export default {
  load,
  save,
  update
}